import { FC, PropsWithChildren } from 'react';

import styles from './row.module.scss';

interface Props extends Required<PropsWithChildren> {
  className?: string;
  variant?: 'primary' | 'secondary';
}

export const TableRow: FC<Props> = ({
  children,
  className = '',
  variant = 'primary',
}) => {
  return (
    <div className={`${styles.row} ${styles[variant]} ${className}`}>
      {children}
    </div>
  );
};
